import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { useStationeryTemplateCategoryTranslations } from '@apps/card/hooks/useStationeryTemplateCategoryTranslations';
import { useTranslation } from '@shared/core';

const Slash = () => <Box as="span">/</Box>;

type BreadcrumbSectionProps = Readonly<{
  category: StationeryTemplateCategoryEnum;
}>;

export const BreadcrumbSection: React.FC<BreadcrumbSectionProps> = ({ category }) => {
  const { tq } = useTranslation('stationery');
  const getCategoryName = useStationeryTemplateCategoryTranslations('designsGalleryPdpBreadcrumbCategory');

  if (category !== StationeryTemplateCategoryEnum.saveTheDate) {
    return null;
  }

  const categoryName = getCategoryName(category);

  return (
    <Box
      width="100%"
      paddingLeft={{ _: 6, sm2: 8 }}
      paddingRight={{ _: 4, sm2: 6 }}
      paddingTop={{ _: 6, md: 8 }}
    >
      <Flex
        typographyVariant="hed2"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        alignItems="center"
        gap={5}
      >
        <Box
          as="span"
          itemScope
          itemProp="itemListElement"
          itemType="https://schema.org/ListItem"
        >
          <Box
            as="a"
            href="https://withjoy.com/"
            itemProp="item"
          >
            <Box
              as="span"
              itemProp="name"
            >
              {tq`Home`}
            </Box>
          </Box>
          <meta
            itemProp="position"
            content="1"
          />
        </Box>
        <Slash />
        <Box
          as="span"
          itemScope
          itemProp="itemListElement"
          itemType="https://schema.org/ListItem"
        >
          <Box
            as="span"
            color="mono10"
            cursor="default"
            itemProp="name"
          >
            {categoryName}
          </Box>
          <meta
            itemProp="position"
            content="2"
          />
        </Box>
      </Flex>
    </Box>
  );
};
